export const environment = {
  production: true,
  environment_name: 'tablebay',
  environment_title: 'Table Bay Mall',
  environment_url: 'https://www.tablebaymall.co.za/',
  environment: 'prod',
  api_base_url: 'https://api.hyprop.co.za/',
  api_auth_url: 'https://auth-api.hyprop.co.za/',
  cdn_url: 'https://cdn.hyprop.co.za/',
  mall_id: 'e65c83cd-9f1b-46ca-8c78-fb11f07b78a1',
  addressLat: -34.08103595353481,
  addressLng: 18.823019984657062,
  recaptcha_key: '6LeJuCcbAAAAAMiZ_rBgq7NTiEQVrjNZ1J6f1zAL',
  social_google_key:
    '150343683952-08m97b42cr2fc2v4j1qnckfmq1np0hn9.apps.googleusercontent.com',
  social_facebook_key: '253233436432992',
  sso_url: 'https://sso.hyprop.co.za',
  google_verification: 'b9RLQzOrFwgByEHNQX8wxMuf4NZIFJ2balXlQ8mygaM',
  street_address: 'Cnr R27 (West Coast Road), Berkshire Boulevard, Sunningdale',
  address_locality: 'Cape Town',
  postal_code: '7441',
  address_country: 'ZA',
  contact_form_uuid: 'znagjivd',
  google_api_key: 'AIzaSyCEvUD2-2IuJdnY4mCmiPHjrdjDsskcTG8',
  form4_link:
    'https://cdn.hyprop.co.za/document/2024/2/19/b2213e98-9cbe-4799-9eb2-b336daeca01f/11e16c5e-b384-447e-b767-91e6055fccf1.pdf',
  tiktok_url: 'https://www.tiktok.com/@tablebaymallct',
};
